import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/main.scss';  // Importing SCSS
import { Provider } from 'react-redux';
import { store } from 'state/store';
import { LocalStorageAuth } from 'utils/LocalStorageAuth';
import { REEL_PLAYER_PATH } from 'components/ReelMaker/reelPlayerLink';

// Getting the root element from the DOM
const rootElement = document.getElementById('root');

if (window.location.hash.startsWith(`#${REEL_PLAYER_PATH}`)) {
  // Public Reel Player (/#/reel-player?d=…): the reel travels inside the URL, so it boots without
  // login, client config or the Redux store. Loaded lazily to keep it out of the main app's path.
  import('./reelPlayerApp').then(({ mountReelPlayerApp }) => mountReelPlayerApp(rootElement!));
} else {
  // Capture an SSO token delivered on the Direct Reports deep link before the app
  // boots, so the global auth init restores the fresh session directly instead of
  // failing on a stale token and bouncing the deep link to login/dashboard.
  LocalStorageAuth.captureDeepLinkSsoToken();

  // Creating the React root
  const root = createRoot(rootElement!); // '!' ensures that rootElement is not null

  // Rendering the App component into the DOM
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>
  );
}
